<!-- Responsibility: Render vitals badges (vitality, spirit, essence) for any game entity.
Scope: Vitals display only; owned by character sheets, player profile, NPC/companion dialogs. -->
<vitals>
  <div class="vitals">
    <span class="tooltip-wrap">
      ❤ { vitals()?.vitality ?? 0 }
      <div class="tooltip" data-position="top" data-tip-custom="true"><b>VITALITY</b><br/>Physical health and injury tolerance.</div>
    </span>
    <span class="tooltip-wrap">
      ✦ { vitals()?.spirit ?? 0 }
      <div class="tooltip" data-position="top" data-tip-custom="true"><b>SPIRIT</b><br/>Mental focus and willpower reserves.</div>
    </span>
    <span class="tooltip-wrap">
      ✿ { vitals()?.essence ?? 0 }
      <div class="tooltip" data-position="top" data-tip-custom="true"><b>ESSENCE</b><br/>Life force and magical potential.</div>
    </span>
  </div>

  <script>
    export default {
      vitals() {
        return this.props.vitals || {}
      },
    }
  </script>

  <style>
    .vitals {
      display: flex;
      gap: var(--space-xs);
      flex-wrap: wrap;
    }

    .vitals > span {
      border: 1px solid var(--border);
      background: color-mix(in srgb, var(--surface-card-3) var(--alpha-high), var(--bg));
      border-radius: 62.4375rem;
      padding: var(--space-xs) 0.58rem;
      font-size: calc(0.66rem + 0.01rem);
      letter-spacing: 0.06em;
      color: var(--text-prose);
      box-shadow: inset 0 1px 0 var(--alpha-ghost);
      cursor: default;
      user-select: none;
    }

    .vitals > span:nth-child(1) {
      border-color: color-mix(in srgb, var(--vital-hp) var(--alpha-mid), var(--border));
      color: var(--vital-hp);
    }

    .vitals > span:nth-child(2) {
      border-color: color-mix(in srgb, var(--vital-sp) var(--alpha-mid), var(--border));
      color: var(--vital-sp);
    }

    .vitals > span:nth-child(3) {
      border-color: color-mix(in srgb, var(--vital-es) var(--alpha-mid), var(--border));
      color: var(--vital-es);
    }
  </style>
</vitals>
